import React from "react";
import { Box } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useSelector } from "react-redux";

import numberFormatter from "utils/numberFormatter";
import Bar from "components/visuals/Bar";

import { selectors } from "modules/customer/insights/performance/sales/regionalGrowthBreakdown";
import stringUtils from "utils/stringUtils";

const SalesByRegionGrowthBottom = () => {
    const theme = useTheme();
    let title = "Bottom stores for year-on-year revenue growth (%)";
    const selectedRegion = useSelector(state => selectors.selectedRegion(state));
    const totalSalesGrowthByRegion = useSelector(state => selectors.totalSalesGrowthByRegion(state));
    if(selectedRegion) {
        const regionName = totalSalesGrowthByRegion.regionsGrowth.find(r => r.regionId === selectedRegion).regionName;
        title += ` (${regionName})`;
    }
    const salesByRegionGrowthTopBottom = useSelector(state => selectors.salesByRegionGrowthTopBottom(state));
    const { loading, error, bottom } = salesByRegionGrowthTopBottom;
    bottom.sort((a, b) => b.growth - a.growth);
    const options = {
        chart:{
            height: "240px"
        },
        title: {
            text: title
        },
        colors: [
            theme.palette.error.main
        ],
        yAxis: {
            labels: {
                formatter: function() {return numberFormatter.toPercentage(this.value);}
            },
            gridLineWidth: 0
        },
        xAxis: {
            categories: bottom.map(store => store.storeName),
            title: {
                text: null
            }
        },
        plotOptions: {
            series: {
                dataLabels: {
                        enabled: false
                }
            }
        },
        legend:{
            enabled:true,
        },
        tooltip: {
            enabled: true,
            formatter: function() {
                const store = this.x;
                const growth = numberFormatter.toPercentage(this.y);
                const sales = numberFormatter.toGBP(this.point.custom.sales);
                return `<table>${stringUtils.tooltipHTML(['Revenue: ', 'Growth (%): '], {
                    header: store,
                    headerFormatting: `color:${this.color}`,
                    values: [sales, growth]
                })}</table>`;
            },
            useHTML: true
        },
        series: [{
            name: 'Low growth',
            data: bottom.map(store => {
                return {
                    y: store.growth,
                    custom: {
                        sales: store.sales
                    }
                };
            })
        }]
    };

    return (
        <Box data-cy="sales-by-region-growth-bottom">
            <Bar loading={loading} error={error} options={options} />
        </Box>
    );
};

export default SalesByRegionGrowthBottom;
